const styles = {
  container: {
    padding: '30px',
    minHeight: '100vh',
    backgroundColor: '#f4f6f9',
    fontFamily: 'Segoe UI, sans-serif',
  },
  header: {
    color: '#1B019B',
    fontWeight: '600',
    fontSize: '1.5rem',
    textAlign: 'center',
  },
  hr: {
    width: '80px',
    border: '2px solid #1B019B',
    opacity: '1',
    margin: '10px auto',
  },
  organisationHeader: {
    backgroundColor: '#fff', 
    padding: '20px', 
    borderRadius: '12px', 
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    marginBottom: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  filterContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    marginBottom: '30px',
    gap: '15px'
  },
  filterGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  dateInput: {
    borderRadius: '20px',
    padding: '8px 12px',
    fontSize: '1rem',
    border: '1px solid #ccc',
    minWidth: '150px',
    height: '38px'
  },
  select: {
    borderRadius: '20px',
    padding: '7px 12px',
    fontSize: '1rem',
    border: '1px solid #ccc',
    minWidth: '180px',
    height: '38px'
  },
  tableHeader: {
    backgroundColor: '#1B019B',
    color: '#fff',
  },
  badgeEnAttente: {
    backgroundColor: '#ffc107',
    color: '#000',
    padding: '4px 8px',
    borderRadius: '4px',
    fontSize: '0.85rem',
    fontWeight: '500'
  },
  badgeApprouvee: {
    backgroundColor: '#28a745',
    color: '#fff',
    padding: '4px 8px',
    borderRadius: '4px',
    fontSize: '0.85rem',
    fontWeight: '500'
  },
  badgeRefusee: {
    backgroundColor: '#dc3545',
    color: '#fff',
    padding: '4px 8px',
    borderRadius: '4px',
    fontSize: '0.85rem',
    fontWeight: '500'
  },
  badgeInconnu: {
    backgroundColor: '#6c757d',
    color: '#fff',
    padding: '4px 8px',
    borderRadius: '4px',
    fontSize: '0.85rem',
    fontWeight: '500'
  },
  actionButtons: {
    display: 'flex',
    gap: '8px',
    justifyContent: 'center'
  },
  detailButton: {
    background: 'none',
    border: 'none',
    color: '#1B019B',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    fontWeight: '500',
  },
  approveButton: {
    backgroundColor: '#28a745',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    padding: '6px 10px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  refuseButton: {
    backgroundColor: '#dc3545',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    padding: '6px 10px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  fileLink: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '6px 12px',
    border: '1px solid #1B019B',
    borderRadius: '6px',
    color: '#1B019B',
    textDecoration: 'none',
    fontWeight: '500',
    transition: 'all 0.2s',
  },
  modalBackdrop: {
    position: 'fixed',
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContent: {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '8px',
    width: '400px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
  },
  detailGrid: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  },
  detailItem: {
    padding: '8px 0',
    borderBottom: '1px solid #eee'
  },
  justificationText: {
    marginTop: '5px',
    padding: '8px',
    backgroundColor: '#f8f9fa',
    borderRadius: '4px',
    maxHeight: '150px',
    overflowY: 'auto',
    wordBreak: 'break-word'
  },
  paginationButton: { 
    backgroundColor: '#1B019B', 
    color: 'white', 
    border: 'none', 
    margin: '0 2px', 
    borderRadius: '5px', 
    padding: '5px 10px' 
  },
  paginationActive: { 
    backgroundColor: '#0d0066', 
    color: 'white' 
  },
  paginationDisabled: { 
    backgroundColor: '#e0e0e0', 
    color: '#a0a0a0', 
    cursor: 'not-allowed' 
  },

    
    searchInput: {
    paddingLeft: '35px',
    },
    searchIcon: {
    position: 'absolute',
    left: '10px',
    top: '50%',
    transform: 'translateY(-50%)',
    color: '#6c757d',
    },
    resetButton: {
    height: '38px', 
    },  
};

export default styles;